import { render, staticRenderFns } from "./paySlipDetails.vue?vue&type=template&id=0535abb4&scoped=true"
import script from "./paySlipDetails.vue?vue&type=script&lang=js"
export * from "./paySlipDetails.vue?vue&type=script&lang=js"
import style0 from "./paySlipDetails.vue?vue&type=style&index=0&id=0535abb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535abb4",
  null
  
)

export default component.exports